module.exports = __webpack_public_path__ + "static/img/mainbg.735303cc.png";